import React, { useEffect, useState } from 'react'
import { InputContainer } from '../../../../../../common/components/form/form.module';
import _ from 'lodash';
import { RateCardDistanceActionComponent } from './rate-card-distance-action.component';
import RateCardWeightActionComponent from './rate-card-weight.component';
import RateCardBasicChargeActionComponent from './rate-card-basic-charge.component';
import RateCardDurationActionComponent from './rate-card-duration-charge.component';
import RateCardTotalChargeActionComponent from './rate-card-Total-charges.component';
import { RateCardVehicleCategory } from './rate-card-vehicle-category.component';

export default function ModalRateCardRuleComponent({ addTaxonomyRow, taxonomy, removeTaxonomy, handleFormItemChange, Close, vehicleCategories, vehicleList, vehicleBodyTypes, Logisticss,
    messageDelayPeriod, weights, distances, selectedRateCards, shippingTypes, shipmentTypePreference, handleItemSubmit, selectLogistics, onInnerBasicFormChange }: any) {
    const [selectDisUnit, setSelectDisUnit] = useState<any>()
    const [selectWeightUnit, setSelectWeightUnit] = useState<any>()
    const [selectPackUnit, setSelectPackUnit] = useState<any>()
    const [selectDuraionUnit, setSelectDuraionUnit] = useState<any>()
    const [isOpenDis, setIsOpenDis] = useState(false);
    const [isOpenWeig, setIsOpenWeig] = useState(false);
    const [isOpenCharge, setIsOpenCharge] = useState(false);
    const [isOpenDur, setIsOpenDur] = useState(false);
    const [isOpenTotalCal, setIsOpenTotalCal] = useState(false);
    const timeSlots = [
        {
            Disabled: false,
            Selected: false,
            Text: '10 AM to 12 PM',
            Description: '10 AM to 12 PM',
            Value: 10
        },
        {
            Disabled: false,
            Selected: false,
            Text: '12 PM to 2 PM',
            Description: '12 PM to 2 PM',
            Value: 20
        },
        {
            Disabled: false,
            Selected: false,
            Text: '2 PM to 4 PM',
            Description: '2 PM to 4 PM',
            Value: 30
        },
        {
            Disabled: false,
            Selected: false,
            Text: '4 PM to 6 PM',
            Description: '4 PM to 6 PM',
            Value: 40
        }
    ]
    useEffect(() => {
        if (selectLogistics?.DistanceUnitId) {
            const selectedDistanceUnit = _.find(
                distances,
                (item) => String(item.Id) === selectLogistics?.DistanceUnitId
            );

            setSelectDisUnit(selectedDistanceUnit)
        }
        if (selectLogistics?.WeightUnitId) {
            const selectedWeightUnit = _.find(
                weights,
                (item) => String(item.Id) === selectLogistics?.WeightUnitId
            );

            setSelectWeightUnit(selectedWeightUnit)
        }
        if (selectLogistics?.PackageSizeUnit) {
            const selectedPackUnit = _.find(
                distances,
                (item) => String(item.Id) === selectLogistics?.PackageSizeUnit
            );
            setSelectPackUnit(selectedPackUnit)
        }
        if (selectLogistics?.DurationUnitId) {
            const selectedDurationUnit = _.find(
                messageDelayPeriod,
                (item) => String(item.Value) === selectLogistics?.DurationUnitId
            );

            setSelectDuraionUnit(selectedDurationUnit)
        }


    }, [selectLogistics])

    const distanceBaseMax = Number(selectLogistics?.MaximumDistance)
    const distanceIncrement = Number(selectLogistics?.DistanceIncrement)
    const distanceChargePerIncrement = Number(selectLogistics?.DistanceIncrementCharge)
    const weightBaseMax = Number(selectLogistics?.MaximumWeight)
    const weightIncrement = Number(selectLogistics?.WeightIncrement)
    const weightChargePerIncrement = Number(selectLogistics?.WeightIncrementCharge)
    const durationBaseMax = Number(selectLogistics?.Duration)
    const durationIncrement = Number(selectLogistics?.DurationIncrement)
    const durationChargePerIncrement = Number(selectLogistics?.WaitingCharge)


    // Toggle function
    const openDis = () => {
        setIsOpenDis((prev) => !prev);
    };
    const openWeig = () => {
        setIsOpenWeig((prev) => !prev);
    }
    const openCharge = () => {
        setIsOpenCharge((prev) => !prev);
    }
    const openDuration = () => {
        setIsOpenDur((prev) => !prev);
    }
    const totalCal = () => {
        setIsOpenTotalCal((prev) => !prev);
    }
    return (

        <div className="  w-full p-2 bg-white shadow-md rounded-md">
            <div className="text-xl font-bold mb-4 text-center">Add RateCard Rule</div>
            <div className='border'>
                <div className='px-2 py-4'>
                    <div className='text-base font-medium'>Basic Details</div>
                    <div className='text-xs font-normal mb-4 text-opacity-50 text-black'>Basic Info</div>
                    <div className="grid grid-cols-3 gap-4">
                        <div className="w-full">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Name
                            </label>

                            <input
                                type="text"
                                name="value"
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'Name',

                                    )
                                }}
                                value={selectLogistics?.Name}
                            />


                        </div>
                        <div className="w-full ">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Shipping Preference
                            </label>

                            <select
                                required
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                id="default"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'ShippingTypePreferenceId'

                                    );
                                }}
                                value={selectLogistics?.ShippingTypePreferenceId}
                            >

                                <option>--Select--</option>
                                {shipmentTypePreference?.map((item: any, index: any) => (
                                    <option value={item.Value} key={index}>{item.Text}</option>
                                )
                                )}

                            </select>

                        </div>
                        <div className="w-full ">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Shipping Type
                            </label>

                            <select
                                required
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                id="default"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'ShippingTypeId'

                                    );
                                }}
                                value={selectLogistics?.ShippingTypeId}
                            >

                                <option>--Select--</option>
                                {shippingTypes?.map((item: any, index: any) => (
                                    <option value={item.Id} key={index}>{item.ShippingTypeName}</option>
                                )
                                )}

                            </select>

                        </div>
                        <div className="w-full">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Average Delivery Time
                            </label>

                            <input
                                type="text"
                                name="value"
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'AverageDeliveryTime',

                                    )
                                }}
                                value={selectLogistics?.AverageDeliveryTime}
                            />


                        </div>
                    </div>

                </div>
                <div className='border-b'></div>
                <div className='px-2 py-4'>
                    <div className='text-base font-medium'>Basic Charges Details</div>
                    <div className="text-xs font-normal mb-4 text-opacity-50 text-black">
                        {selectedRateCards?.LogisticsOrderType !== 'Cargo' ? 'If you want to include charges for  Delivery and RTO, please provide the values in the input fields below.' : 'If you want to include charges for Vehicle Rent, Delivery, RTO, Fuel, Peak Season, and Toll, please provide the values in the input fields below.'}
                    </div>
                    <div className="grid grid-cols-6 gap-3">

                        {selectedRateCards?.LogisticsOrderType == 'Cargo' ?
                            <div className="w-full">
                                <label
                                    className="block text-xs font-bold mb-1"
                                >
                                    Include Trip Base Price
                                </label>

                                <input
                                    type="checkbox"
                                    name="IsIncludeVehicleAmount"
                                    className="h-5 w-5 border border-black/50 rounded cursor-pointer"
                                    onChange={(event: any) => {
                                        onInnerBasicFormChange(
                                            event.target.checked,
                                            'IsIncludeVehicleAmount'
                                        );
                                    }}
                                    checked={selectLogistics?.IsIncludeVehicleAmount}
                                />
                            </div> : null
                        }
                        <div className="w-full">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Delivery
                            </label>

                            <input
                                required
                                type="number"
                                name="DeliveryCharge"
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'DeliveryCharge',

                                    )
                                }}
                                value={selectLogistics?.DeliveryCharge}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in ₹
                            </span>
                        </div>
                        <div className="w-full">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                RTO
                            </label>

                            <input
                                required
                                type="number"
                                name="RTOCharge"
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'RTOCharge',

                                    )
                                }}
                                value={selectLogistics?.RTOCharge}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in ₹
                            </span>
                        </div>

                        {selectedRateCards?.LogisticsOrderType == 'Cargo' ?

                            <><div className="w-full">
                                <label
                                    className="block text-xs font-bold mb-1"
                                >
                                    Fuel
                                </label>

                                <input

                                    type="number"
                                    name="FuelCharge"
                                    className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                    onChange={(event: any) => {
                                        onInnerBasicFormChange(
                                            event.target.value,
                                            'FuelCharge',

                                        )
                                    }}
                                    value={selectLogistics?.FuelCharge}
                                />

                                <span
                                    className="block text-xs font-light text-right"
                                >
                                    in ₹
                                </span>
                            </div>
                                <div className="w-full">
                                    <label
                                        className="block text-xs font-bold mb-1"
                                    >
                                        Peak Season
                                    </label>

                                    <input

                                        type="number"
                                        name="Peak Season Charge"
                                        className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                        onChange={(event: any) => {
                                            onInnerBasicFormChange(
                                                event.target.value,
                                                'PeakSeasonCharge',

                                            )
                                        }}
                                        value={selectLogistics?.PeakSeasonCharge}
                                    />

                                    <span
                                        className="block text-xs font-light text-right"
                                    >
                                        in ₹
                                    </span>
                                </div>
                                <div className="w-full">
                                    <label
                                        className="block text-xs font-bold mb-1"
                                    >
                                        Toll
                                    </label>

                                    <input

                                        type="number"
                                        name="TollCharge"
                                        className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                        onChange={(event: any) => {
                                            onInnerBasicFormChange(
                                                event.target.value,
                                                'TollCharge',

                                            )
                                        }}
                                        value={selectLogistics?.TollCharge}
                                    />

                                    <span
                                        className="block text-xs font-light text-right"
                                    >
                                        in ₹
                                    </span>
                                </div> </>
                            : null}
                    </div>
                    <div className='flex justify-end items-center w-full'>
                        <button
                            disabled={!selectLogistics?.DeliveryCharge}
                            title={`${!selectLogistics?.DeliveryCharge ? "Fill all the Inputs" : "calculate given value"}`}
                            className={`px-2 text-xs ${!selectLogistics?.DeliveryCharge ? "text-blue-600 opacity-50" : "text-blue-600"}  underline font-medium`}
                            onClick={openCharge}
                        >
                            Action
                        </button>
                    </div>
                    {isOpenCharge && (
                        <div>

                            <RateCardBasicChargeActionComponent
                                vehicle={selectLogistics?.IsIncludeVehicleAmount}
                                delivery={selectLogistics?.DeliveryCharge}
                                rto={selectLogistics?.RTOCharge}
                                fuel={selectLogistics?.FuelCharge}
                                peakSeason={selectLogistics?.PeakSeasonCharge}
                                toll={selectLogistics?.TollCharge}
                            />
                        </div>)}
                </div>
                <div className='border-b'></div>
                <div className='px-2 py-4'>
                    <div className='text-base font-medium'>Distance Basic Charges Details</div>
                    <div className='text-xs font-normal mb-4 text-opacity-50 text-black'>
                        If you want to include distance charges, please provide the minimum distance, maximum distance, and increment distance. The charges will increase based on each increment distance
                    </div>
                    <div className="grid grid-cols-5 gap-4">

                        <div className="w-full ">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Unit
                            </label>

                            <select
                                required
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                id="default"
                                onChange={(event: any) => {

                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'DistanceUnitId',

                                    );
                                }}
                                value={selectLogistics?.DistanceUnitId}
                            >

                                <option>--Select--</option>
                                {distances?.map((item: any, index: any) => (
                                    <option value={item.Id} key={index}>{item.SystemKeyword}</option>
                                )
                                )}

                            </select>

                        </div>
                        <div className="w-full">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Minimun
                            </label>

                            <input
                                required
                                type="number"
                                name="MinimunDistance"
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'MinimunDistance',

                                    )
                                }}
                                value={selectLogistics?.MinimunDistance}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in {selectDisUnit?.SystemKeyword || 'km'}
                            </span>
                        </div>
                        <div className="w-full">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Maximum
                            </label>

                            <input
                                required
                                type="number"
                                name="MaximumDistance"
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'MaximumDistance',

                                    )
                                }}
                                value={selectLogistics?.MaximumDistance}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in {selectDisUnit?.SystemKeyword || 'km'}
                            </span>
                        </div>
                        <div className="w-full">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Increase
                            </label>

                            <input
                                required
                                type="number"
                                name="DistanceIncrement"
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'DistanceIncrement',

                                    )
                                }}
                                value={selectLogistics?.DistanceIncrement}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in {selectDisUnit?.SystemKeyword || 'km'}
                            </span>
                        </div>
                        <div className="w-full">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Charge
                            </label>

                            <input
                                required
                                type="number"
                                name="DistanceIncrementCharge"
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'DistanceIncrementCharge',

                                    )
                                }}
                                value={selectLogistics?.DistanceIncrementCharge}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in ₹
                            </span>
                        </div>

                    </div>
                    <div className='flex justify-end items-center w-full'>
                        <button
                            disabled={!selectLogistics?.DistanceIncrementCharge}
                            title={`${!selectLogistics?.DistanceIncrementCharge ? "Fill all the Inputs" : "calculate given value"}`}
                            className={`px-2 text-xs ${!selectLogistics?.DistanceIncrementCharge ? "text-blue-600 opacity-50" : "text-blue-600"}  underline font-medium`}
                            onClick={openDis}
                        >
                            Action
                        </button>
                    </div>
                    {isOpenDis && (
                        <div>

                            <RateCardDistanceActionComponent
                                selectDisUnit={selectDisUnit?.SystemKeyword}
                                distanceBaseMax={distanceBaseMax}
                                distanceIncrement={distanceIncrement}
                                distanceChargePerIncrement={distanceChargePerIncrement}
                            />

                        </div>)}
                </div>
                <div className='border-b'></div>
                <div className='px-2 py-4'>
                    <div className='text-base font-medium'>Vehicle category Charges Details</div>
                    <div className='text-xs font-normal mb-4 text-opacity-50 text-black'>
                        If you want to include distance-based charges, please provide the minimum distance, maximum distance, and distance increment. The charges will increase based on each increment, and will vary according to the vehicle category.
                    </div>
                    <RateCardVehicleCategory
                        taxonomy={taxonomy}
                        distances={distances}
                        vehicleCategories={vehicleCategories}
                        handleFormItemChange={handleFormItemChange}
                        vehicleBodyTypes={vehicleBodyTypes}
                        vehicleList={vehicleList}
                        removeTaxonomy={removeTaxonomy}
                        addTaxonomyRow={addTaxonomyRow}

                    />
                </div>
                <div className='border-b'></div>
                <div className='px-2 py-4'>
                    <div className='text-base font-medium'>Weight Charges Details</div>
                    <div className='text-xs font-normal mb-4 text-opacity-50 text-black'>
                        If you want to include Weight charges, please provide the minimum Weight, maximum Weight, and increment Weight. The charges will increase based on each increment Weight.
                    </div>
                    <div className="grid grid-cols-5 gap-4">

                        <div className="w-full ">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Unit
                            </label>

                            <select
                                required
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                id="default"
                                onChange={(event: any) => {

                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'WeightUnitId',

                                    );
                                }}
                                value={selectLogistics?.WeightUnitId}
                            >

                                <option>--Select--</option>
                                {weights?.map((item: any, index: any) => (
                                    <option value={item.Id} key={index}>{item.SystemKeyword}</option>
                                )
                                )}

                            </select>

                        </div>
                        <div className="w-full">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Minimun
                            </label>

                            <input
                                required
                                type="number"
                                name="MinimumWeight"
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'MinimumWeight',

                                    )
                                }}
                                value={selectLogistics?.MinimumWeight}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in {selectWeightUnit?.SystemKeyword || 'kg'}
                            </span>
                        </div>
                        <div className="w-full">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Maximum
                            </label>

                            <input
                                required
                                type="number"
                                name="MaximumWeight"
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'MaximumWeight',

                                    )
                                }}
                                value={selectLogistics?.MaximumWeight}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in {selectWeightUnit?.SystemKeyword || 'kg'}
                            </span>
                        </div>
                        <div className="w-full">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Increase
                            </label>

                            <input
                                required
                                type="number"
                                name="WeightIncrement"
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'WeightIncrement',

                                    )
                                }}
                                value={selectLogistics?.WeightIncrement}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in {selectWeightUnit?.SystemKeyword || 'kg'}
                            </span>
                        </div>
                        <div className="w-full">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Charge
                            </label>

                            <input
                                required
                                type="number"
                                name="WeightIncrementCharge"
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'WeightIncrementCharge',

                                    )
                                }}
                                value={selectLogistics?.WeightIncrementCharge}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in ₹
                            </span>
                        </div>

                    </div>
                    <div className='flex justify-end items-center w-full'>
                        <button
                            disabled={!selectLogistics?.WeightIncrementCharge}
                            title={`${!selectLogistics?.WeightIncrementCharge ? "Fill all the Inputs" : "calculate given value"}`}
                            className={`px-2 text-xs ${!selectLogistics?.WeightIncrementCharge ? "text-blue-600 opacity-50" : "text-blue-600"}  underline font-medium`}
                            onClick={openWeig}
                        >
                            Action
                        </button>
                    </div>
                    {isOpenWeig && (
                        <RateCardWeightActionComponent
                            selectWeightUnit={selectWeightUnit?.SystemKeyword}
                            weightBaseMax={weightBaseMax}
                            weightIncrement={weightIncrement}
                            weightChargePerIncrement={weightChargePerIncrement}
                        />
                    )}
                </div>
                <div className='border-b'></div>
                <div className='px-2 py-4'>
                    <div className='text-base font-medium'>Package Details</div>
                    <div className='text-xs font-normal mb-4 text-opacity-50 text-black'>If you want to include more details about package, please provide the values in the input fields below.</div>
                    <div className="grid grid-cols-5 gap-4">

                        <div className="w-full ">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Unit
                            </label>

                            <select
                                required
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                id="default"
                                onChange={(event: any) => {

                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'PackageSizeUnit',

                                    );
                                }}
                                value={selectLogistics?.PackageSizeUnit}
                            >

                                <option>--Select--</option>
                                {distances?.map((item: any, index: any) => (
                                    <option value={item.Id} key={index}>{item.SystemKeyword}</option>
                                )
                                )}

                            </select>

                        </div>
                        <div className="w-full">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Min Length
                            </label>

                            <input
                                required
                                type="number"
                                name="MinimumLength"
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'MinimumLength',

                                    )
                                }}
                                value={selectLogistics?.MinimumLength}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in {selectPackUnit?.SystemKeyword || 'cm'}
                            </span>
                        </div>
                        <div className="w-full">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Max Length
                            </label>

                            <input
                                required
                                type="number"
                                name="MaximumLength"
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'MaximumLength',

                                    )
                                }}
                                value={selectLogistics?.MaximumLength}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in {selectPackUnit?.SystemKeyword || 'cm'}
                            </span>
                        </div>
                        <div className="w-full">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Min Width
                            </label>

                            <input
                                required
                                type="number"
                                name="MinimumBreadth"
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'MinimumBreadth',

                                    )
                                }}
                                value={selectLogistics?.MinimumBreadth}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in {selectPackUnit?.SystemKeyword || 'cm'}
                            </span>
                        </div>
                        <div className="w-full">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Max Width
                            </label>

                            <input
                                required
                                type="number"
                                name="MaximumBreadth"
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'MaximumBreadth',

                                    )
                                }}
                                value={selectLogistics?.MaximumBreadth}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in {selectPackUnit?.SystemKeyword || 'cm'}
                            </span>
                        </div>
                        <div className="w-full">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Min Height
                            </label>

                            <input
                                required
                                type="number"
                                name="MinimumHeight"
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'MinimumHeight',

                                    )
                                }}
                                value={selectLogistics?.MinimumHeight}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in {selectPackUnit?.SystemKeyword || 'cm'}
                            </span>
                        </div>
                        <div className="w-full">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Max Height
                            </label>

                            <input
                                required
                                type="number"
                                name="MaximumHeight"
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'MaximumHeight',

                                    )
                                }}
                                value={selectLogistics?.MaximumHeight}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in {selectPackUnit?.SystemKeyword || 'cm'}
                            </span>
                        </div>
                    </div>

                </div>
                <div className='border-b'></div>
                <div className='px-2 py-4'>
                    <div className='text-base font-medium'>Duration And Waiting Charges Details</div>
                    <div className='text-xs font-normal mb-4 text-opacity-50 text-black'>If you want to include waiting charges, please provide the Duration, and increment Duration. The waiting charges will increase based on each increment Duration.</div>
                    <div className="grid grid-cols-4 gap-4">
                        <div className="w-full ">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Unit
                            </label>

                            <select
                                required
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                id="default"
                                onChange={(event: any) => {

                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'DurationUnitId',

                                    );
                                }}
                                value={selectLogistics?.DurationUnitId}
                            >

                                <option>--Select--</option>
                                {messageDelayPeriod?.map((item: any, index: any) => (
                                    <option value={item.Value} key={index}>{item.Text}</option>
                                )
                                )}

                            </select>

                        </div>
                        <div className="w-full">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Duration
                            </label>

                            <input
                                required
                                type="number"
                                name="Duration"
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'Duration',

                                    )
                                }}
                                value={selectLogistics?.Duration}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in {selectDuraionUnit?.Text || 'Minutes'}
                            </span>
                        </div>
                        <div className="w-full">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Increase Duration
                            </label>

                            <input
                                required
                                type="number"
                                name="DurationIncrement"
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'DurationIncrement',

                                    )
                                }}
                                value={selectLogistics?.DurationIncrement}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in {selectDuraionUnit?.Text || 'Minutes'}
                            </span>
                        </div>
                        <div className="w-full">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Waiting Charge
                            </label>

                            <input
                                required
                                type="number"
                                name="WaitingCharge"
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                onChange={(event: any) => {
                                    onInnerBasicFormChange(
                                        event.target.value,
                                        'WaitingCharge',

                                    )
                                }}
                                value={selectLogistics?.WaitingCharge}
                            />

                            <span
                                className="block text-xs font-light text-right"
                            >
                                in ₹
                            </span>
                        </div>

                    </div>
                    <div className="grid grid-cols-2 gap-4">
                        <div className="w-full ">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Pickup TimeSlots
                            </label>

                            <InputContainer

                                labelField="Text"
                                list={timeSlots}
                                onValueChange={(newValue: any) => {
                                    const timeSlotsData: any = newValue.map((option: any) => option?.value || '')
                                    onInnerBasicFormChange(
                                        timeSlotsData,
                                        'PickupTimeSlots',

                                    )
                                }}
                                type="multiselect"
                                valueField="Text"
                                value={selectLogistics?.PickupTimeSlots}
                            />

                        </div>
                        <div className="w-full ">
                            <label
                                className="block text-xs font-bold mb-1"
                            >
                                Delivery TimeSlots
                            </label>

                            <InputContainer

                                labelField="Text"
                                list={timeSlots}
                                onValueChange={(newValue: any) => {
                                    const timeSlotsData: any = newValue.map((option: any) => option?.value || '')
                                    onInnerBasicFormChange(
                                        timeSlotsData,
                                        'DeliveryTimeSlots',

                                    )
                                }}
                                type="multiselect"
                                valueField="Text"
                                value={selectLogistics?.DeliveryTimeSlots}
                            />

                        </div>
                    </div>
                    <div className='flex justify-end items-center w-full'>
                        <button
                            disabled={!selectLogistics?.WaitingCharge}
                            title={`${!selectLogistics?.WaitingCharge ? "Fill all the Inputs" : "calculate given value"}`}
                            className={`px-2 text-xs ${!selectLogistics?.WaitingCharge ? "text-blue-600 opacity-50" : "text-blue-600"}  underline font-medium`}
                            onClick={openDuration}
                        >
                            Action
                        </button>
                    </div>
                    {isOpenDur && (
                        <div>

                            <RateCardDurationActionComponent
                                selectDurUnit={selectDuraionUnit?.Text}
                                durationBaseMax={durationBaseMax}
                                durationIncrement={durationIncrement}
                                durationChargePerIncrement={durationChargePerIncrement}
                            />
                        </div>)}
                </div>
                <div className='border-b'></div>
                <div className='px-2 py-4'>
                    <div className='text-base font-medium'>Action Details</div>
                    <div className='text-xs font-normal mb-4 text-opacity-50 text-black'>This action provides a basic sample calculation based on the given rate card rules for your reference.</div>

                    <div className="">
                        <button
                            className={` rounded font-semibold text-lg p-3 border-2 border-gray-700 text-primary
                                `}
                            onClick={totalCal}
                        >
                            Total Charges calculate
                        </button>

                    </div>
                    {isOpenTotalCal && (
                        <div>

                            <RateCardTotalChargeActionComponent
                                vehicle={selectLogistics?.IsIncludeVehicleAmount}
                                delivery={selectLogistics?.DeliveryCharge}
                                rto={selectLogistics?.RTOCharge}
                                fuel={selectLogistics?.FuelCharge}
                                peakSeason={selectLogistics?.PeakSeasonCharge}
                                toll={selectLogistics?.TollCharge}
                                durationCharge={durationChargePerIncrement}
                                distanceCharge={distanceChargePerIncrement}
                                weightCharge={weightChargePerIncrement}
                            />
                        </div>)}
                </div>
            </div>
            <div className="flex justify-end mt-6">
                <button
                    onClick={Close}
                    type="button"
                    className="m-2 bg-primary text-light rounded font-medium px-4 py-3"
                >
                    Close
                </button>
                <button
                    className="m-2 bg-primary text-light rounded font-medium px-4 py-3"
                    onClick={handleItemSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>

        </div>



    )
}